var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftDrinksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "soft-drinks-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---App-views",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products",
    transform: "translate(-46, -457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(22, 433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "soft-drinks-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "soft_drinks",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#00414B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.2935, 2.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8258782,0.842173333 C11.9034782,0.356973333 12.3220116,0 12.8133449,0 L20.4133449,0 C20.9656116,0 21.4133449,0.44772 21.4133449,1 C21.4133449,1.55228 20.9656116,2 20.4133449,2 L13.6661449,2 L13.0418782,5.90666667 L16.2000116,5.90666667 C16.4877449,5.90666667 16.7616116,6.03062667 16.9514782,6.24685333 C17.1413449,6.46309333 17.2288116,6.75064 17.1916116,7.03597333 L14.6582782,26.4626667 C14.5933449,26.9606667 14.1689449,27.3333333 13.6666782,27.3333333 L3.53334491,27.3333333 C3.03103824,27.3333333 2.60669158,26.9606667 2.54173158,26.4626667 L0.00839824267,7.03597333 C-0.0288017573,6.75064 0.0587049093,6.46309333 0.248571576,6.24685333 C0.438438243,6.03062667 0.712251576,5.90666667 1.00001158,5.90666667 L11.0164116,5.90666667 L11.8258782,0.842173333 Z M10.6968116,7.90666667 L2.13887824,7.90666667 L4.41139824,25.3333333 L12.7886782,25.3333333 L15.0610782,7.90666667 L12.7221449,7.90666667 L10.4274782,22.2645333 C10.3402782,22.8098667 9.82761158,23.1813333 9.28214491,23.0941333 C8.73681158,23.0069333 8.36534491,22.4942667 8.45254491,21.9488 L10.6968116,7.90666667 Z",
    id: "Shape",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74670491,11.44 C7.29899824,11.44 7.74670491,10.99228 7.74670491,10.44 C7.74670491,9.88772 7.29899824,9.44 6.74670491,9.44 C6.19442491,9.44 5.74670491,9.88772 5.74670491,10.44 C5.74670491,10.99228 6.19442491,11.44 6.74670491,11.44 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74670491,18.2 C7.29899824,18.2 7.74670491,17.7522667 7.74670491,17.2 C7.74670491,16.6477333 7.29899824,16.2 6.74670491,16.2 C6.19442491,16.2 5.74670491,16.6477333 5.74670491,17.2 C5.74670491,17.7522667 6.19442491,18.2 6.74670491,18.2 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06670491,14.8266667 C5.61899824,14.8266667 6.06670491,14.3789333 6.06670491,13.8266667 C6.06670491,13.2744 5.61899824,12.8266667 5.06670491,12.8266667 C4.51442491,12.8266667 4.06670491,13.2744 4.06670491,13.8266667 C4.06670491,14.3789333 4.51442491,14.8266667 5.06670491,14.8266667 Z",
    id: "Path",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftDrinksIcon);
export default __webpack_public_path__ + "static/media/soft-drinks-icon.7a5c302b4e006d604031b6413958f34c.svg";
export { ForwardRef as ReactComponent };